module.exports = __webpack_public_path__ + "static/media/download.4b773988.png";